import React from "react";
import fetch from './_AdminCustomFetch'
 // Selected organisation is a context
 const selectedOrgContext = React.createContext({
     selectedOrg: "Not set",
     setSelectedOrg: () => {}          // empty function that gets defined later (by sidebar in our case)
 });   // Context so all child components can access this

export default selectedOrgContext;